import React, { useState } from "react";
import axios from "axios";
import "../styles/ForgetPass.css";
import { API_URL } from '../config';

// 1. Usando template literals (comillas invertidas)
const API = `${API_URL}/api`;

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    try {
      await axios.post(`${API}/auth/password-reset/`, { email });
      setSent(true);
    } catch {
      setMsg("Ocurrió un error al enviar el enlace. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="fp-wrap">
        <div className="fp-card">
          <div className="fp-header">
            <h2 className="fp-title">¡Revisa tu correo!</h2>
            <p className="fp-subtitle">
              Si existe una cuenta con <b>{email}</b>, te enviamos un enlace para restablecer tu contraseña.
            </p>
          </div>
          <div className="fp-success">
            <p className="fp-help">No lo ves? Mira en Spam o Promociones.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fp-wrap">
      <div className="fp-card">
        <div className="fp-header">
          <h2 className="fp-title">Restablecer contraseña</h2>
          <p className="fp-subtitle">Ingresa tu correo y te enviaremos un enlace de restablecimiento.</p>
        </div>

        <form className="fp-form" onSubmit={submit}>
          <label className="fp-label" htmlFor="email">Correo electrónico</label>
          <input
            id="email"
            className="fp-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ejemplo@correo.com"
            autoComplete="email"
          />

          {msg && <div className="fp-alert fp-alert-error">{msg}</div>}

          <button className="fp-btn" type="submit" disabled={loading}>
            {loading ? "Enviando…" : "Enviar enlace"}
          </button>

          <p className="fp-help">Usaremos este correo solo para enviarte el link seguro.</p>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
